import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import CustomerReviewViewModel, { CustomerReview } from "viewModels/customerReview/customerReviewViewModel";
import { ratingTypeIcon } from "utils/ratingTypeIcon";
import { Input } from "@frui.ts/bootstrap";
import Button from "@edaz/edazkit/Button";
import { Card, Form, Col } from "react-bootstrap";
import { RadioArray } from "controls/radioArray";
import { successMessage } from "utils/ratingTypeIcon/ratingAssets";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
export const CustomerReviewView: ViewComponent<CustomerReviewViewModel> = observer(({ vm }) => {
  const translate = (code: string) => vm.translate(code);
  const controlId = `customer-review-form`;
  const labelContent = (index: React.Key | null | undefined, review: CustomerReview) => (
    <Card.Body className="d-flex align-items-center justify-content-center p-0">
      <div className="d-flex flex-column justify-content-cente align-items-center" key={index}>
        <img src={ratingTypeIcon(review.value, vm.isDisabled)} />
        <span className="mt-1">{translate(`customerRatingScore.${review.value}`)}</span>
      </div>
    </Card.Body>
  );

  const successContent = () => {
    return (
      <div id="success-rating-card" className="d-flex flex-column card-box-shadow mb-0 mb-md-0 mb-sm-3 p-5 p-md-7 jumbotron">
        <div className="d-flex flex-column justify-content-cente align-items-center">
          <img src={successMessage} style={{ maxHeight: "5rem", width: "auto" }} />
        </div>
        <h4 className="mt-3 mb-4 text-center">{translate("successTitle")}</h4>
        <span className="mb-5 text-center">{translate("successMessage")}</span>
      </div>
    );
  };

  const ratingContet = () => {
    return (
      <div className="d-flex flex-column align-items-center card-box-shadow mb-0 mb-md-0 mb-sm-3 p-5 p-md-7 jumbotron">
        <h4 className="mb-3">{translate("title")}</h4>
        <span className="mb-5 text-center">{translate("question")}</span>
        <div className="mb-5 customer-rating-wrapper">
          {vm.customerReviews.map((review, index) => (
            <Card
              key={index}
              className={`customer-rating-view ${review.value === vm.ratingScore ? vm.customerReviewColor(review.value) : ""} ${
                vm.isDisabled ? "disabled" : ""
              }`}>
              <RadioArray
                custom
                label={labelContent(index, review)}
                className={`customer-rating-select d-flex align-items-center label-stretch pl-0 `}
                name={"customerRating"}
                target={vm.customerRating}
                property="score"
                isNumeric={false}
                resetOnClick
                id={review.id}
                option={review.value}
                disabled={vm.isDisabled}
                isInvalid={!!vm.error}
              />
            </Card>
          ))}
        </div>
        <div className="w-100">
          <Form.Group controlId={controlId} as={Col} sm={12} className="my-0 p-0">
            {vm.rating.score && (
              <>
                <Form.Label>
                  <span className="mr-3">{translate("comment")}</span>
                </Form.Label>
                <Input
                  as="textarea"
                  className="w-100"
                  target={vm.customerRating}
                  property={"comment"}
                  disabled={vm.isDisabled}
                  placeholder={translate("customRatingPlaceholder")}
                />
                <div style={{ textAlign: "end", color: "#bdc7d1" }}>{`${vm.customerRating.comment?.length ?? 0}/1000`}</div>
              </>
            )}
          </Form.Group>
          {vm.errorMessage && (
            <AlertWithInfoIcon variant="warning" className="mt-2 mb-5" key={vm.errorMessage}>
              {vm.errorMessage ? vm.translateError(vm.errorMessage) : translate("warning")}
            </AlertWithInfoIcon>
          )}
          <Button onClick={vm.onSubmit} className="d-block mx-auto" disabled={vm.isDisabled || vm.isDisabledConfirm()}>
            {translate("submit")}
          </Button>
        </div>
      </div>
    );
  };

  return vm.step === 1 ? ratingContet() : successContent();
});

registerView(CustomerReviewView, CustomerReviewViewModel);
